import { AuthState } from '@okta/okta-auth-js';

import { CommoditiesSummaries } from '../../services/backend/CommoditiesSummaries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommoditiesSummaries: () => CommoditiesSummaries<AuthState> = () => {
  return useBaseApiClient(CommoditiesSummaries);
};
